{
  "aiGeneratedAnswer": "AI-genererat svar",
  "allCategories": "Alla kategorier",
  "appliedFiltersToCurrentSearch": "Tillämpade filter för aktuell sökning",
  "apply": "Tillämpa",
  "applyFilters": "Tillämpa filter",
  "autocompleteOptionsFound_one": "{{count}}{{label}} autofyllningsval hittades.",
  "autocompleteOptionsFound_other": "{{count}}{{label}} autofyllningsval hittades.",
  "autocompleteSuggestion": "autofyllningsförslag: {{suggestion}}",
  "autocompleteSuggestionsFound_one": "{{count}} autofyllningsförslag hittades.",
  "autocompleteSuggestionsFound_other": "{{count}} autofyllningsförslag hittades.",
  "basedOnYourDevice": " (baserat på din enhet)",
  "basedOnYourInternetAddress": " (baserat på din internetadress)",
  "categoriesText_one": "Följande kategori gav resultat för – <strong>{{query}}</strong>",
  "categoriesText_other": "Följande kategorier gav resultat för – <strong>{{query}}</strong>",
  "clearAll": "Rensa allt",
  "clearMinAndMax": "Rensa min och max",
  "clearTheRangeToSelectOptions": "Rensa intervallet för att välja alternativ.",
  "clearTheSearchBar": "Rensa sökfältet",
  "conductASearch": "Utför en sökning",
  "currentLocation": "Aktuell plats",
  "didYouMean": "Menade du <button>{{correctedQuery}}</button>?",
  "dropDownScreenReaderInstructions": "När autofyllningsresultat är tillgängliga, använd upp- och nedpilar för att bläddra och enter för att välja.",
  "feedback": "Feedback",
  "invalidRange": "Ogiltigt intervall",
  "max": "Max",
  "min": "Min",
  "navigateToTheNextResultsPage": "Gå till nästa resultatsida",
  "navigateToThePreviousResultsPage": "Gå till föregående resultatsida",
  "noAutocompleteOptionsFound": "0 autofyllningsval hittades.",
  "noAutocompleteSuggestionsFound": "0 autofyllningsförslag hittades.",
  "noResultsFoundIn": "Inga resultat hittades i {{currentVerticalLabel}}.",
  "pagination": "Pagination",
  "readMoreAbout": "Läs mer om <a>{{name}}</a>",
  "recentSearch": "senaste sökningen: {{query}}",
  "recentSearchesFound_one": "{{count}} senaste sökning hittades.",
  "recentSearchesFound_other": "{{count}} senaste sökningar hittades.",
  "removeFilter": "Ta bort filtret \"{{displayName}}\"",
  "resultPreview": "resultatförhandsgranskning: {{value}}",
  "resultPreviewsFound_one": "{{count}} förhandsgranskning hittades.",
  "resultPreviewsFound_other": "{{count}} förhandsgranskningar hittades.",
  "resultsCountText_one": "{{count}} resultat",
  "resultsCountText_other": "{{count}} resultat",
  "resultsCountWithPaginationText": "{{paginateStart}}–{{paginateEnd}} av {{resultsCount}} resultat",
  "searchHere": "Sök här…",
  "showLess": "Visa mindre",
  "showMore": "Visa mer",
  "showingAllInstead": "Visar alla {{currentVerticalLabel}} i stället.",
  "sources_one": "Källa",
  "sources_other": "Källor ({{count}})",
  "submitSearch": "Skicka sökning",
  "suggestionResultsCount_one": "{{label}} – {{count}} resultat",
  "suggestionResultsCount_other": "{{label}} – {{count}} resultat",
  "thankYouForYourFeedback": "Tack för din feedback!",
  "thisAnsweredMyQuestion": "Detta besvarade min fråga",
  "thisDidNotAnswerMyQuestion": "Detta besvarade inte min fråga",
  "unselectAnOptionToEnterInARange": "Avmarkera ett alternativ för att ange ett intervall.",
  "updateYourLocation": "Uppdatera din plats",
  "useCurrentLocation": "Använd aktuell plats",
  "useMyLocation": "Använd min plats",
  "viewAll": "Visa alla",
  "viewDetails": "Visa detaljer"
}
